import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProgressBarService {

  student = '';
  studentAddress = '';
  firstGuardian = '';
  emergencyContact = '';
  providerAndPharmacy = '';
  insurance = '';
  hippa = '';
  myNortonChart = '';
  medicalAndSurgicalHistory = '';
  tobaccoAlcohol = '';
  permissionToExamine = '';
  authorize = '';
  signature = '';

  constructor() { }

  set(isStaff: boolean) {
    if (isStaff) {
      this.student = '9%';
      this.studentAddress = '18%';
      this.emergencyContact = '27%';
      this.providerAndPharmacy = '36%';
      this.insurance = '45%';
      this.hippa = '54%';
      this.myNortonChart = '63%';
      this.medicalAndSurgicalHistory = '72%';
      this.tobaccoAlcohol = '81%';
      this.authorize = '90%';
      this.signature = '100%';
    } else {
      this.student = '8%';
      this.studentAddress = '16%';
      this.firstGuardian = '24%';
      this.emergencyContact = '32%';
      this.providerAndPharmacy = '40%';
      this.insurance = '48%';
      this.hippa = '56%';
      this.myNortonChart = '72%';
      this.medicalAndSurgicalHistory = '80%';
      this.permissionToExamine = '88%';
      this.authorize = '96%';
      this.signature = '100%';
    }
  }

}
